/* Stylesheet */

.primary_fab_button {
  --background: var(--ion-color-primary);
  --box-shadow: none;
  color: #ffffff;
}

.small {
  margin: 0;
  height: 32px;
  width: 32px;

  .icon {
    height: 18px;
    width: 18px;
  }
}

.primary {
  --background: var(--ion-gradient-dark-transparent);
  --box-shadow: var(--ion-box-shadow);
}

.transparent {
  --background: transparent;
}
